// src/routes/SalesRoutes.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'primeicons/primeicons.css';
import BottomNav from '../Pages/SalesApp/SalesShared/BottomNav/BottomNav';
import Order from '../Pages/SalesApp/Orders/Order';
import SalesHeader from '../Pages/SalesApp/SalesShared/SalesHeader/SalesHeader';
import Account from '../Pages/SalesApp/Accounts/account';
import OrderHistory from '../Pages/SalesApp/OrderHistory/OrderHistory';
import SOHistory from '../Pages/SalesApp/OrderHistory/SOHistory';
import DeliveryHistory from '../Pages/SalesApp/delivery/deliveryHistory';
import DeliveryItems from '../Pages/SalesApp/delivery/deliveryItems';
import InvoiceHistory from '../Pages/SalesApp/InvoiceHistory/invoiceHistory';
import DocumentItems from '../Pages/SalesApp/delivery/deliveryItems';

const SalesRoutes = () => {

  return (
    <div className='salesRoute'>
      <SalesHeader />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Order />} />
          <Route path="/Account" element={<Account />} />
          <Route path="/OrderHistory" element={<OrderHistory />} />
          <Route path="/SOHistory" element={<SOHistory />} />
          <Route path="/deliveryHistory" element={<DeliveryHistory />} />
          {/* <Route path="/deliveryItems" element={<DeliveryItems />} /> */}
          <Route path="/invoiceHistory" element={<InvoiceHistory />} />
          <Route path="/HistoryItems" element={<DocumentItems />} />
        </Routes>
      </div>
      <BottomNav />
    </div>
  );
};

export default SalesRoutes;
